module.exports = __webpack_public_path__ + "black_logo-1cc26e066fe90a0ad34f00a4990d378b.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/black_logo.png
// module id = 99
// module chunks = 0 1